import { Routes } from "@angular/router";
import { content } from "./shared/routes/routes";
import { AuthGuard } from "./shared/directive/auth.guard";

export const routes: Routes = [
  {
    path: "auth/login",
    loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: "auth/forgot-password",
    loadComponent: () => import('./auth/forgot-password/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
  },
  {
    path: "auth/reset-password/:token/:email",
    loadComponent: () => import('./auth/reset-password/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
  },
  {
    path: "",
    loadComponent: () => import('./shared/components/layout/content/content.component').then(m => m.ContentComponent),
    children: content,
    canActivate: [AuthGuard],
  },
  {
    path: "**",
    redirectTo: "error-page/error-400",
    pathMatch: "full",
  },
];
